import {
  JsonFormat,
  objectJsonFormat,
  stringJsonFormat,
} from "@redotech/json/format";
import { commonIntegrationJsonFormatFields } from "../integration/integration-json-format";
import { PostscriptIntegration } from "./postscript-integration-schema-definition";

export const postscriptIntegrationJsonFormat: JsonFormat<PostscriptIntegration> =
  objectJsonFormat(
    { ...commonIntegrationJsonFormatFields, privateApiKey: stringJsonFormat },
    {},
  );
